import { useEffect, useState, ReactElement } from 'react';
import { getUserPhoto } from 'config/authConfig';
import { Avatar, Box, Typography } from '@mui/material';

type AccountInfoProps = {
  division: string;
  userName: string;
};

export const AccountInfo = ({ division, userName }: AccountInfoProps): ReactElement => {
  const [userPhoto, setUserPhoto] = useState<string | undefined>();

  useEffect(() => {
    async function fetchUserPhoto() {
      const photo = await getUserPhoto();
      setUserPhoto(photo);
    }

    fetchUserPhoto();
  }, []);

  const capitalize = (str: string): string => {
    const firstLetterCapitalized = str.charAt(0).toUpperCase();
    return firstLetterCapitalized + str.slice(1);
  };

  const getUserInitials = () => {
    const userNameSplit = userName.split(' ');
    const firstInitial = userNameSplit[0].charAt(0);
    const lastInitial = userNameSplit[userNameSplit.length - 1].charAt(0);
    return firstInitial + lastInitial;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: 300, justifyContent: 'flex-end', alignItems: 'center' }}>
      <Box sx={{ flexDirection: 'column', alignItems: 'end', mr: 1.5 }}>
        <Typography align="right" sx={{ lineHeight: 1, mt: 0.8 }}>
          {userName}
        </Typography>
        <Typography variant="body2" align="right" color={'#b3c6dc'}>
          {capitalize(division)}
        </Typography>
      </Box>
      {userPhoto ? (
        <Avatar data-testid="avatar" src={userPhoto} sx={{ height: 45, width: 45, backgroundColor: 'white' }} />
      ) : (
        <Avatar sx={{ height: 45, width: 45, pt: 0.5 }}>{getUserInitials()}</Avatar>
      )}
    </Box>
  );
};

export default AccountInfo;
